"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["durationInFrames", "children"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Series = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var Sequence_1 = require("../Sequence");

var validate_duration_in_frames_1 = require("../validation/validate-duration-in-frames");

var flatten_children_1 = require("./flatten-children");

var SeriesSequenceRefForwardingFunction = function SeriesSequenceRefForwardingFunction(_ref2, _ref) {
  var children = _ref2.children;
  // Discard ref
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: children
  });
};

var SeriesSequence = (0, react_1.forwardRef)(SeriesSequenceRefForwardingFunction);

var Series = function Series(_ref3) {
  var children = _ref3.children;
  var childrenValue = (0, react_1.useMemo)(function () {
    var startFrame = 0;
    return react_1.Children.map((0, flatten_children_1.flattenChildren)(children), function (child, i) {
      var _a;

      var castedChild = child;

      if (typeof castedChild === 'string') {
        // Don't throw if it's just some accidential whitespace
        if (castedChild.trim() === '') {
          return null;
        }

        throw new TypeError("The <Series /> component only accepts a list of <Series.Sequence /> components as it's children, but you passed a string \"".concat(castedChild, "\""));
      }

      if (castedChild.type !== SeriesSequence) {
        throw new TypeError("The <Series /> component only accepts a list of <Series.Sequence /> components as it's children, but got ".concat(castedChild, " instead"));
      }

      var debugInfo = "index = ".concat(i, ", duration = ").concat(castedChild.props.durationInFrames);

      if (!castedChild || !castedChild.props.children) {
        throw new TypeError("A <Series.Sequence /> component (".concat(debugInfo, ") was detected to not have any children. Delete it to fix this error."));
      }

      var durationInFramesProp = castedChild.props.durationInFrames;

      var _castedChild$props = castedChild.props,
          durationInFrames = _castedChild$props.durationInFrames,
          _children = _castedChild$props.children,
          passedProps = _objectWithoutProperties(_castedChild$props, _excluded);

      (0, validate_duration_in_frames_1.validateDurationInFrames)(durationInFramesProp, "of a <Series.Sequence /> component");
      var offset = (_a = castedChild.props.offset) !== null && _a !== void 0 ? _a : 0;

      if (Number.isNaN(offset)) {
        throw new TypeError("The \"offset\" property of a <Series.Sequence /> must not be NaN, but got NaN (".concat(debugInfo, ")."));
      }

      if (!Number.isFinite(offset)) {
        throw new TypeError("The \"offset\" property of a <Series.Sequence /> must be finite, but got ".concat(offset, " (").concat(debugInfo, ")."));
      }

      if (offset % 1 !== 0) {
        throw new TypeError("The \"offset\" property of a <Series.Sequence /> must be finite, but got ".concat(offset, " (").concat(debugInfo, ")."));
      }

      var currentStartFrame = startFrame + offset;
      startFrame += durationInFramesProp + offset;
      return (0, jsx_runtime_1.jsx)(Sequence_1.Sequence, _objectSpread(_objectSpread({
        from: currentStartFrame,
        durationInFrames: durationInFramesProp
      }, passedProps), {}, {
        ref: castedChild.ref,
        children: child
      }));
    });
  }, [children]);
  /* eslint-disable react/jsx-no-useless-fragment */

  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: childrenValue
  });
};

exports.Series = Series;
Series.Sequence = SeriesSequence;